import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function HomeAbout() {
    return (
        <Container>
            <div className="row mt-5 mb-2">
                <div className='col' >
                    <h3 className='homeabout-title'> CCTV Installation Services in Hyderbad </h3>
                </div>
            </div>
            <div className="row mt-3 mb-5">
                <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12'>
                    <img className="homeabout-image" src="/images/home/about2.jpg" alt="Loading.." />
                </div>
                <div className=" col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 homeabout-col">
                    <p> Royality Technologies will provide all your security needs with advanced security solutions</p>
                    <p> The increase in vandalism, theft and assault in recent years has seen an unprecedented rise in the installation of CCTV security systems in Hyderabad. </p>
                    <p> Security systems not only act as a deterrent, but they are also the perfect surveillance tool. Surveillance systems have been useful in bringing thousands of criminals to justice. They offer you, your company’s staff, and your customer’s peace of mind, especially in places such as car parks, dimly lit areas, and other places where people feel unguarded. </p>
                    <p> With years of experience in the security field for installing CCTV Home Security Cameras: Dome, IP, IP Bullet, Wifi CCTV and Biometric. Our professional staff and technicians are experienced in providing CCTV security services to the areas of Hyderabad, and we specialize in providing solutions for stores, supermarkets, malls, educational facilities, hospitals, banks, government buildings, industrial complex sites, and the protection of critical infrastructure. </p> <div />
                    {/* <p> Quality is the most important for any security product or CCTV Home Security Systems. </p> */}
                    {/* <Link to="/about" className="about-link" >Know More</Link> */}
                </div>
            </div>
        </Container>
    )
}

export default HomeAbout